import { gql } from "apollo-boost";

export const GET_CATEGORY = gql`
  query allCategory($catId: Int, $catName: String) {
    allCategory(catId: $catId, catName: $catName) {
      edges {
        node {
          catId
          catName
          catNameRus
          catDesc
          catDescRus
          catType
        }
      }
    }
  }
`;

export const GET_CATEGORY_VALUE = gql`
  query allCategoryValue(
    $catId: Int
    $catName: String
    $valId: Int
    $valName: String
  ) {
    allCategoryValue(
      catId: $catId
      catName: $catName
      valId: $valId
      valName: $valName
    ) {
      edges {
        node {
          valId
          valName
          valNameRus
          valDesc
          valDescRus
          obsolete
          catId
          category {
            catName
          }
        }
      }
    }
  }
`;

export const GET_USERS = gql`
  query(
    $userId: Int
    $userEmail: String
    $password: String
    $googleId: String
    $facebookId: String
  ) {
    allUser(
      userId: $userId
      userEmail: $userEmail
      password: $password
      googleId: $googleId
      facebookId: $facebookId
    ) {
      edges {
        node {
          userId
          userName
          userEmail
          gender
          createDate
          password
          passwordResetcode
          photo
          role
          birthDate
          state
          country
          language
          googleId
          facebookId
          id
          userAccess {
            edges {
              node {
                seqNo
                userId
                clubId
                accessLevel
                isDefault
                club {
                  clubName
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const USER_MERGE = gql`
  mutation MutateUser(
    $userId: Int
    $userName: String
    $password: String
    $passwordResetcode: String
    $photo: String
    $role: String
    $userEmail: String
    $birthDate: Date
    $gender: String
    $state: String
    $country: String
    $language: String
    $googleId: String
    $facebookId: String
    $updateSource: String!
  ) {
    userMerge(
      userData: {
        userId: $userId
        userName: $userName
        password: $password
        passwordResetcode: $passwordResetcode
        photo: $photo
        role: $role
        userEmail: $userEmail
        birthDate: $birthDate
        gender: $gender
        state: $state
        country: $country
        language: $language
        googleId: $googleId
        facebookId: $facebookId
        updateSource: $updateSource
      }
    ) {
      node {
        userId
        userName
        password
        passwordResetcode
        photo
        role
        userEmail
        createDate
        birthDate
        gender
        state
        country
        language
        googleId
        facebookId
        updateSource
      }
    }
  }
`;

export const USER_DELETE = gql`
  mutation userDelete($userId: Int!) {
    userDelete(userId: $userId) {
      status
    }
  }
`;
export const GET_USER_ACCESS = gql`
  query allUserAcces {
    allUserAcces {
      edges {
        node {
          seqNo
          userId
          clubId
          accessLevel
        }
      }
    }
  }
`;

export const SIGN_IN_USER = gql`
  mutation signInUser(
    $userId: Int
    $userEmail: String
    $password: String
    $googleId: String
    $facebookId: String
  ) {
    signInUser(
      userData: {
        userId: $userId
        userEmail: $userEmail
        password: $password
        googleId: $googleId
        facebookId: $facebookId
      }
    ) {
      userDetails {
        userId
        userEmail
        password
        accessToken
        refreshToken
        message
      }
    }
  }
`;

export const GET_CURRENT_USER = gql`
  mutation getCurrentUser {
    getCurrentUser {
      userEmail
      userId
      userName
      photo
      role
      createDate
      birthDate
      gender
      state
      country
      language
      googleId
      facebookId
    }
  }
`;

export const GET_NEW_TOKEN = gql`
  mutation getNewAccessToken {
    getNewAccessToken {
      newAccessToken
    }
  }
`;

/*User Queries */

/*Post Mutations*/

/*User Mutations*/
export const CAT_VALUE_MERGE = gql`
  mutation CatValueMerge(
    $valId: Int
    $catId: Int!
    $valName: String!
    $valDesc: String!
    $obsolete: String!
    $updateSource: String!
  ) {
    catValueMerge(
      categoryValueData: {
        valId: $valId
        catId: $catId
        valName: $valName
        valDesc: $valDesc
        obsolete: $obsolete
        updateSource: $updateSource
      }
    ) {
      node {
        valId
        catId
        valName
        valDesc
        obsolete
        updateSource
      }
    }
  }
`;

export const CAT_VALUE_DELETE = gql`
  mutation catValueDelete($valId: Int!) {
    catValueDelete(valId: $valId) {
      status
    }
  }
`;

export const VENDOR_QRY = gql`
  query {
    allVendor {
      edges {
        node {
          vendorSeqno
          vendorId
          vendorName
          vendorDesc
          vendorType
          website
          address
          city
          state
          postalCode
          country
          portal
          portalDetails
          contactPerson
          contactNumber
          contactEmail
          status
          logo
          updateSource
        }
      }
    }
  }
`;

export const VENDOR_MERGE = gql`
  mutation VendorMerge(
    $vendorSeqno: Int
    $vendorId: String!
    $vendorName: String!
    $vendorDesc: String
    $vendorType: String
    $website: String
    $address: String
    $city: String
    $state: String
    $postalCode: String
    $country: String
    $contactPerson: String
    $contactEmail: String
    $contactNumber: String
    $portal: String
    $portalDetails: String
    $logo: String
    $updateSource: String!
  ) {
    vendorMerge(
      vendorData: {
        vendorSeqno: $vendorSeqno
        vendorId: $vendorId
        vendorName: $vendorName
        vendorDesc: $vendorDesc
        vendorType: $vendorType
        website: $website
        address: $address
        city: $city
        state: $state
        postalCode: $postalCode
        country: $country
        contactPerson: $contactPerson
        contactEmail: $contactEmail
        contactNumber: $contactNumber
        portal: $portal
        portalDetails: $portalDetails
        logo: $logo
        updateSource: $updateSource
      }
    ) {
      node {
        vendorSeqno
        vendorId
        vendorName
        vendorDesc
        vendorType
        website
        address
        city
        state
        postalCode
        country
        portal
        portalDetails
        contactPerson
        contactNumber
        contactEmail
        status
        logo
        updateSource
      }
    }
  }
`;

export const VENDOR_DELETE = gql`
  mutation vendorDelete($vendorSeqno: Int!) {
    vendorDelete(vendorSeqno: $vendorSeqno) {
      status
    }
  }
`;
